import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
    mode: 'history',
    saveScrollPosition: true,
    scrollBehavior: function(to, from, savedPosition) {
        if (savedPosition)
            return savedPosition
        if (to.hash)
            return {selector: to.hash}
        return false
    },
    routes: [
        {
            path: '/',
            name: 'Main',
            component: function (resolve) { require(['@/pages/Main.vue'], resolve) }
        },
        {
            path: '/projects',
            name: 'Projects',
            component: function (resolve) { require(['@/pages/Projects.vue'], resolve) }
        },
        {
            path: '/projects/:alias',
            name: 'Project',
            component: function (resolve) { require(['@/pages/Project.vue'], resolve) }
        },
        {
            path: '/blog',
            name: 'Blog',
            component: function (resolve) { require(['@/pages/Blog.vue'], resolve) }
        },
        {
            path: '/blog/:alias',
            name: 'BlogPost',
            component: function (resolve) { require(['@/pages/BlogPost.vue'], resolve) }
        },
        {
            path: '/studio',
            name: 'Studio',
            component: function (resolve) { require(['@/pages/Studio.vue'], resolve) }
        },
        {
            path: '/contacts',
            name: 'Contacts',
            component: function (resolve) { require(['@/pages/Contacts.vue'], resolve) }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router.js